import './App.css';
import Main from './components/Main';
import MapTestOnClick from './components/MapTestOnClick';


function App() {
  return (
    <div className="App" style={{  backgroundColor: 'black' }}>
       <Main />
    </div>
  );
}

export default App;
